import Button from "components/Button/Button";
import Card from "components/Card/Card";
import KaboodleModal from "components/Modals/KaboodleModal";

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  fileName?: string;
  isDeleting?: boolean;
  count?: number;
}

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  fileName,
  isDeleting = false,
  count,
}: DeleteConfirmationModalProps) => {
  const isMultiple = count !== undefined && count > 1;
  // Selected rows may sit on another page, so only the count is reliable here.
  const message =
    count === undefined
      ? `Are you sure you want to delete "${fileName}"?`
      : `Are you sure you want to delete ${count} ${isMultiple ? "documents" : "document"}?`;

  return (
    <KaboodleModal
      isOpen={isOpen}
      onClose={onClose}
      footer={
        <div className="flex jc-c">
          <Button className="delete" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? "Deleting..." : "Confirm Delete"}
          </Button>
          <Button onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
        </div>
      }
    >
      <Card heading={isMultiple ? "Delete Documents" : "Delete Document"}>
        <p>{message}</p>
        <p>This action cannot be undone.</p>
      </Card>
    </KaboodleModal>
  );
};

export default DeleteConfirmationModal;
